const getOperatorsRevenues = (revenues: any) => {
  let data: any = [];
  revenues.forEach((revenue: any) => {
    let list: any = [];
    let cost: number = 0;
    let discount: number = 0;
    let gp: number = 0;

    let gross_profit: number = 0;
    let net: number = 0;
    let hours_sold: any = 0;

    revenue.list.forEach((item: any) => {

       const separate = item?.rts_code.split("/");

       const sec = separate[1]?.charAt(0);

       if (
         sec !== "G" &&
         sec !== "B" &&
         item?.rts_code !== "CONS" &&
         item?.department !== "P"
       ) {
         cost = cost + item.cost_value;
         discount = discount + item.discount;
         gross_profit = gross_profit + item.gross_profit;
         gp = gp + item.profit_percentage;
         gp = gp + item.profit_percentage;
         net = net + item.sales_value;
         hours_sold = hours_sold + item.hours_sold;
         list.push(item);
       }
    });
    const rev = {
      _id: revenue?._id,
      cost,
      discount,
      gross_profit,
      gp,
      net,
      hours_sold,
      list,
    };
    revenue.list = list;
    data.push(rev);
  });
  return data;
};

export default getOperatorsRevenues;
